export default __webpack_public_path__ + "static/media/txt-paste.dbd6da11.svg";